import { render } from "./Chips.vue?vue&type=template&id=5025693e&scoped=true"
import script from "./Chips.vue?vue&type=script&lang=js"
export * from "./Chips.vue?vue&type=script&lang=js"

import "./Chips.vue?vue&type=style&index=0&id=5025693e&lang=scss&scoped=true"

import exportComponent from "/var/www/miniapp-sigur-admin-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5025693e"],['__file',"src/assets/js/components/Chips.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5025693e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5025693e', __exports__)) {
    api.reload('5025693e', __exports__)
  }
  
  module.hot.accept("./Chips.vue?vue&type=template&id=5025693e&scoped=true", () => {
    api.rerender('5025693e', render)
  })

}


export default __exports__